define('modules/page_generator/page_amp_renderer',['require','exports','module','modules/editor/models/editorstate','modules/editor/views/page','env','lib/util','jquery','ldsh!./templates/generator_amp_popup','ldsh!./templates/generator_amp_page','ldsh!./templates/generator_amp_popup_preview','ldsh!./templates/generator_amp_page'],function (require, exports, module) {
  "use strict";
  var EditorState = require("modules/editor/models/editorstate"),
    PageRenderView = require("modules/editor/views/page"),
    config = require("env"),
    util = require('lib/util'),
    $ = require("jquery");

  var PageRenderer = module.exports = function (variant) {
    this.variant = variant;

    EditorState.setVariant(variant);
    EditorState.setAMPState(true);
  };

  _.extend(PageRenderer.prototype, {
    pageTemplate: function (model) {
      return this.getPageTemplate(model);
    },

    getPageTemplate: function (model) {
      return (
        EditorState.isCurrentStepPopup() ?
          require('ldsh!./templates/generator_amp_popup') :
          require('ldsh!./templates/generator_amp_page')
      )(model);
    },

    previewTemplate: function (model) {
      return this.getPreviewTemplate(model);
    },

    getPreviewTemplate: function (model) {
      return (
        EditorState.isCurrentStepPopup() ?
          require('ldsh!./templates/generator_amp_popup_preview') :
          require('ldsh!./templates/generator_amp_page')
      )(model);
    },

    generatePreview: function (step) {
      step || (step = 0);

      var stepModel = this.variant.getContentForStep(step);
      return this.previewTemplate(this._buildModelData(stepModel));
    },

    _buildModelData: function (step) {
      EditorState.setActivePage(step);

      var pageProps = this.variant.getPropertyGroup('page:defaults'),
        generatedContent = this._renderPage(step),
        notification = this.variant.getPropertyGroup('page:notification'),
        customAMPScriptModel = this.variant.getPropertyGroup('form:customAMPScript'),
        templateParams = {
          stepId: step.get('step'),
          pageProperties: pageProps.toJSON(),
          popupProperties: this.getPopupStyles(step),
          content: generatedContent.html,
          platform: this.variant.get('platform'),
          styles: this._renderStyles(),
          extractedScripts: generatedContent.extractedScripts,
          extractedStyles: generatedContent.extractedStyles,
          elementStyles: generatedContent.elementStyles,
          base: config.apiHost,
          privacy: notification.toJSON(),
          pixels: this.buildPixelsHTML(),
          gtm: this.buildGTMHTML()
        };

      return templateParams;
    },

    getPopupStyles: function (step) {
      if (step.get('role') !== 'popup') {
        return {};
      }
      var popupProps = this.variant.getPropertyGroup("page:popup").toJSON();
      popupProps.overlayRGBA = util.hexToRgba(popupProps.overlayColor, popupProps.overlayOpacity / 10);
      popupProps.width += !popupProps.width.match(/\d*?%$/) ? 'px' : '';
      popupProps.height += !popupProps.height.match(/\d*?%$/) ? 'px' : '';

      return popupProps;
    },

    buildPixelsHTML: function () {
      var pixelsGroup = this.variant.getPropertyGroup('page:conversion').get('customizedPixel');

      if (pixelsGroup) {
        var pixelsArray = pixelsGroup.split(',');
        return $.map(pixelsArray, function (pixel) {
          var pixelSrc = $.trim(pixel);
          return pixelSrc ?
              '<amp-pixel src="' + pixelSrc + '" layout="nodisplay"></amp-pixel>' :
              '';
        }).join("\n");
      }
    },

    buildGTMHTML: function () {
      var gtmId = this.variant.getPropertyGroup('page:gtm').get("gtmId");
      return gtmId ?
        '<amp-analytics config="' + config.gtmUrl +'?id='+ gtmId +'"></amp-analytics>' :
        '';
    },

    _renderPage: function (pageModel) {
      EditorState.setGenerateMode(true);

      var renderer = new PageRenderView({
        data: pageModel
      });
      renderer.render();

      this._cleanUselessHTMLForRender(renderer.$el);

      var output = this._buildOutputContent(renderer.$el.html());
      renderer.remove();

      EditorState.setGenerateMode(false);

      return output;
    },

    _buildOutputContent: function (content) {
      var elements = {
          scripts: [],
          styles: []
        },
        patterns = [{
          element: 'scripts',
          regex: /(<\s*?script[^>]*>([\s\S]*?)<\/script[^>]*>)/gm
        }, {
          element: 'styles',
          regex: /(<\s*?style[^>]*>([\s\S]*?)<\/style[^>]*>)/gm
        }];

      $.map(patterns, function(pattern) {
        content = content.replace(pattern.regex, function (str, match) {
          elements[pattern.element].push(match);
          return '';
        });
      });

      elements.scripts = elements.scripts.concat(this._getAMPStateScripts(content));

      return {
        html: content,
        elementStyles: this._buildElementStyles(),
        extractedScripts: elements.scripts.join(' '),
        extractedStyles: elements.styles.join(' ')
      };
    },

    _getAMPStateScripts: function(content) {
      var ampStateRegex = /data-amp-state-id\s*?=\s*?"(.*)"\s*?data-amp-state-content\s*?=\s*?"({.*})*"/gim;
      var ampStateMatches, ampStates=[];
      while ((ampStateMatches = ampStateRegex.exec(content)) !== null) {
        if (ampStateMatches.index === ampStateRegex.lastIndex) {
          ampStateRegex.lastIndex++;
        }
        ampStates.push(
          '<amp-state id="' + ampStateMatches[1] +'">' +
          '<script type="application/json">' +
          ampStateMatches[2].replace(/&quot;/g,'"') +
          '</script>' +
          '</amp-state>'
        );
      }

      return ampStates;
    },

    _buildElementStyles: function () {
      return $("style.generated-style").map(function (index, el) {
        return $(el).html();
      }).toArray().join("\n");
    },

    _cleanUselessHTMLForRender: function ($el) {
      //removing draggable and UI controls
      $el
        .find("div[draggable]").removeAttr("draggable").end()
        .find(".margin-control").remove().end()
        .find(".resize-box").remove().end()
        .find(".js-element-toolbar").remove().end()
        .find(".ed-position-box").remove();
    },

    _renderStyles: function () {
      var res = "",
        activePage = EditorState.getActivePage();

      if (!activePage.styles) {
        return res;
      }

      activePage.styles.each(function (style) {
        var styleTag = "";
        if (style.get("isTag")) {
          styleTag += style.get("content") + "\n";
        } else {
          styleTag = "<style type=\"text/css\">\n";
          styleTag += style.get("content") + "\n";
          styleTag += "</style>\n";
        }
        res += styleTag;
      }, this);

      return res;
    },

    generateSteps: function () {
      return this.variant.content.map(this.generateStep, this);
    },

    generateStep: function (step) {
      return this.pageTemplate(this._buildModelData(step));
    }
  });
});

